export default "__VITE_ASSET__583c821d__"